import _ from 'lodash';
import dynamic from 'next/dynamic';
import { FiArrowRightCircle } from 'react-icons/fi';
// import CardFull from 'src/components/cards/card-full';
const CardV = dynamic(import('src/components/cards/card-v'));

const SectionFull = ({ data, count = 4, heading, path = '#', more = true, sectionEvent, sectionCol = 'col-lg-3 col-md-6 col-6', eventDataLayer }) => {
  const checkHeading = heading === `${sectionEvent && sectionEvent[1]?.value}`;
  return (
    <div className='block-wrapper my-5'>
      <div className='block-title'>
        {checkHeading ? (
          <div className='heading-image section-event-5'>
              <a href={path || '#'}>
                <h2>{heading}</h2> <img src={_.find(sectionEvent, { key: 'image' })?.value ? _.find(sectionEvent, { key: 'image' })?.value : ''} alt={heading || 'heading'} width='100%' height='100%' />
              </a>
            </div>
        ) : (
          <h2>{heading}</h2>
        )}
        {more && (
          <a href={path || '#'} className='more'>
            ดูทั้งหมด <FiArrowRightCircle />
          </a>
        )}
      </div>
      <div className={`row block-content ${checkHeading ? 'block-heading' : ''}`}>
        {data.slice(0, count).map((item, index) => (
          <div key={index} className={sectionCol}>
            {/* <CardFull
              data={item}
              description={false}
              size='--small'
              //! DATALAYER
              eventDataLayer={{
                ...eventDataLayer,
                data: {
                  ...eventDataLayer?.data,
                  title: item?.title,
                  index: index + 1
                }
              }}
            /> */}
            <CardV
              data={item}
              description={false}
              badge={true}
              path={item.link}
              //! DATALAYER
              eventDataLayer={{
                ...eventDataLayer,
                data: {
                  ...eventDataLayer?.data,
                  title: item?.title,
                  index: index + 1
                }
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionFull;
